<template>
  <div>
  <a-drawer
    :visible="visible"
    placement="right"
    :width="'70%'"
    :title="drawerTitle"
    :closable="true"
    @close="onClose"
  >
    <div class="vod-question-page">
    <!-- ===== 点位列表（仅当前问卷的点位） ===== -->
    <div class="toolbar">
      <div class="filter-left">
        <a-select v-model="pFilter.sourceType" placeholder="来源类型" allow-clear style="width: 170px">
          <a-select-option value="VOD_SINGLE">VOD_SINGLE 单视频</a-select-option>
          <a-select-option value="MIX_SET_TOPIC">MIX_SET_TOPIC 专题子条目</a-select-option>
        </a-select>
        <a-input v-model="pFilter.videoTitle" placeholder="视频标题搜索" allow-clear style="width: 200px; margin-left: 10px" @keyup.enter="loadPoints(1)" />
        <a-button type="primary" style="margin-left: 10px" @click="loadPoints(1)">查询</a-button>
        <a-button style="margin-left: 10px" @click="resetFilter">重置</a-button>
      </div>
      <a-button type="primary" icon="plus" @click="openPointModal()">新增点位</a-button>
    </div>
    <a-table
      :columns="pointColumns"
      :data-source="points"
      row-key="id"
      size="middle"
      :loading="pLoading"
      :scroll="{ x: 1000 }"
      :pagination="false"
    >
      <template slot="qTitle" slot-scope="text, record">
        {{ qTitleOf(record) }}
        <span class="mono">#{{ record.questionnaireId }}</span>
      </template>
      <template slot="sourceType" slot-scope="text">
        <a-tag :color="text === 'VOD_SINGLE' ? 'blue' : 'purple'">{{ text }}</a-tag>
      </template>
      <template slot="source" slot-scope="text, record">
        <a-tooltip
          v-if="record.videos && record.videos.length > 1"
          overlay-class-name="vp-video-tip"
          :visible="videoTipKey === record.id"
        >
          <template slot="title">
            <div v-for="(v, i) in record.videos" :key="i" class="vp-video-tip-item">
              <span class="vp-video-no">{{ i + 1 }}.</span>{{ v.title || ('ID ' + v.id) }}
            </div>
          </template>
          <div
            class="vp-video-cell"
            @mouseenter="onVideoCellEnter($event, record.id)"
            @mouseleave="videoTipKey = null"
          >
            <div v-for="(v, i) in record.videos" :key="i" class="vp-video-line">
              <span class="vp-video-no">{{ i + 1 }}.</span>{{ v.title || ('ID ' + v.id) }}
            </div>
          </div>
        </a-tooltip>
        <b v-else>{{ record.sourceTitle || ('ID ' + record.sourceId) }}</b>
      </template>
      <template slot="topic" slot-scope="text, record">
        <span v-if="record.sourceType === 'MIX_SET_TOPIC' && record.topicTitle">{{ record.topicTitle }}</span>
        <span v-else class="cfg-hint">—</span>
      </template>
      <template slot="status" slot-scope="text, record">
        <a-switch
          :checked="text === 1"
          :loading="!!statusLoading[record.id]"
          checked-children="开"
          un-checked-children="关"
          @change="checked => togglePointStatus(record, checked)"
        />
      </template>
      <template slot="triggerTime" slot-scope="text">
        <b>{{ text }}</b>s
      </template>
      <template slot="action" slot-scope="text, record">
        <a @click="openPointModal(record)" style="margin-right: 10px;">编辑</a>
        <a-popconfirm title="确认删除该点位？作答记录保留" @confirm="delPoint(record.pointIds || [record.id])">
          <a class="action-danger">删除</a>
        </a-popconfirm>
      </template>
    </a-table>
    <div class="pager-row">
      <span class="pager-info">共 {{ pTotal }} 条记录 第 {{ pPage }} / {{ Math.max(1, Math.ceil(pTotal / pPageSize)) }} 页</span>
      <a-pagination
        v-model="pPage"
        :total="pTotal"
        show-size-changer
        :page-size="pPageSize"
        :page-size-options="['10', '20', '50', '100']"
        @change="loadPoints"
        @showSizeChange="onPageSizeChange"
        show-quick-jumper
      />
    </div>

    <!-- ===== 点位 新增/编辑 弹窗 ===== -->
    <a-modal :visible="pModal.visible" :title="pModal.id ? (pForm.sourceType === 'MIX_SET_TOPIC' ? '编辑点位（专题组 ' + selectedVideoIds.length + ' 个视频）' : '编辑点位 #' + pModal.id) : '新增点位'" width="680px" @cancel="closePModal" @ok="savePoint" :confirm-loading="pModal.saving">
      <a-form-model :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
        <a-form-model-item label="来源类型">
          <a-radio-group v-model="pForm.sourceType" @change="onPTypeChange">
            <a-radio value="VOD_SINGLE">VOD_SINGLE 单视频</a-radio>
            <a-radio value="MIX_SET_TOPIC">MIX_SET_TOPIC 专题子条目</a-radio>
          </a-radio-group>
        </a-form-model-item>

        <!-- 专题选择：仅 MIX_SET_TOPIC -->
        <a-form-model-item v-if="pForm.sourceType === 'MIX_SET_TOPIC'" label="选择专题" required>
          <a-select
            v-model="selectedTopicId"
            show-search
            placeholder="输入专题名称搜索"
            :filter-option="false"
            :not-found-content="topicLoading ? '加载中…' : '未找到匹配专题'"
            style="width: 300px"
            @search="debouncedTopicSearch"
            @change="onTopicPicked"
          >
            <a-select-option v-for="t in topicOptions" :key="t.id" :value="t.id">{{ t.title }} #{{ t.id }}</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item :label="pForm.sourceType === 'MIX_SET_TOPIC' ? '选择子视频（可多选）' : '选择视频'" required>
          <a-select
            v-model="selectedVideoIds"
            :mode="pForm.sourceType === 'MIX_SET_TOPIC' ? 'multiple' : 'single'"
            show-search
            :filter-option="videoFilterOption"
            :placeholder="pForm.sourceType === 'MIX_SET_TOPIC' ? '点击展开该专题全部子视频，可输入搜索' : '点击展开视频列表（按最新创建倒序），可输入搜索'"
            :not-found-content="videoLoading ? '加载中…' : (pForm.sourceType === 'MIX_SET_TOPIC' && !selectedTopicId ? '请先在上方选择专题' : '未找到匹配视频')"
            style="width: 360px"
            :dropdown-style="{ minWidth: '480px', maxHeight: '480px' }"
            :loading="videoLoading"
            @search="onVideoSearchInput"
            @change="onVideoChange"
            @dropdownVisibleChange="onVideoDropdownOpen"
          >
            <a-select-option v-for="v in videoOptions" :key="v.id" :value="v.id">
              <div class="video-option-row">
                <div class="video-option-title">{{ v.title }} <template v-if="v.topicTitle"><span class="video-option-topic">（{{ v.topicTitle }}）</span></template></div>
                <div class="video-option-id">#{{ v.id }}</div>
              </div>
            </a-select-option>
          </a-select>
          <div class="cfg-hint" style="margin-top: 4px">
            <template v-if="selectedVideos.length">已选 {{ selectedVideos.length }} 个：{{ selectedVideos.map(v => v.title).join('、') }}</template>
            <template v-else>未选择</template>
          </div>
        </a-form-model-item>

        <a-form-model-item label="关联问卷" required>
          <a-select v-model="pForm.questionnaireId" show-search option-filter-prop="label" placeholder="选择问卷" style="width: 300px">
            <a-select-option v-for="q in questionnaireOptions" :key="q.id" :value="q.id" :label="q.id + ' · ' + q.title">{{ q.id }} · {{ q.title }}</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="触发秒数" required>
          <a-input-number v-model="pForm.triggerTime" :min="0" style="width: 200px" />
          <span class="cfg-hint" style="margin-left: 8px">播放到该秒弹窗；跳过不算已操作，下次进入仍会触发</span>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    </div>
  </a-drawer>
  </div>
</template>

<script>
import { get, post, put, del } from './api'

export default {
  name: 'VodPointDrawer',
  props: {
    visible: { type: Boolean, default: false },
    questionnaireId: { type: [Number, String], default: null },
    questionnaireTitle: { type: String, default: '' }
  },
  data() {
    return {
      points: [],
      pLoading: false,
      pPage: 1,
      pPageSize: 10,
      pTotal: 0,
      pFilter: { sourceType: undefined, videoTitle: '' },
      // 状态开关的行级 loading，key 为行 id，防止切换中重复点击
      statusLoading: {},

      pModal: { visible: false, id: null, pointIds: null, saving: false },
      pForm: { sourceType: 'VOD_SINGLE', questionnaireId: undefined, triggerTime: undefined },
      questionnaireOptions: [],
      topicOptions: [],
      videoOptions: [],
      selectedTopicId: undefined,
      selectedTopic: null,
      selectedVideoIds: [],
      selectedVideos: [],
      topicLoading: false,
      videoLoading: false,
      topicSearchTimer: null,
      videoSearchTimer: null,
      videoTipKey: null
    }
  },
  computed: {
    drawerTitle() {
      return (this.questionnaireTitle ? this.questionnaireTitle : '问卷 #' + this.questionnaireId) + ' · 视频点位'
    },
    pointColumns() {
      return [
        { 
          title: '序号', 
          key: 'rowNum', 
          width: 60, 
          align: 'center',
          customRender: (text, record, index) => index + 1 
        },
        { 
          title: '问卷名称', 
          key: 'qTitle', 
          width: 200, 
          scopedSlots: { customRender: 'qTitle' } 
        },
        { 
          title: 'ID', 
          dataIndex: 'id', 
          width: 70, 
          align: 'center'
        },
        { 
          title: '来源类型', 
          dataIndex: 'sourceType', 
          width: 120, 
          align: 'center',
          scopedSlots: { customRender: 'sourceType' } 
        },  
        { 
          title: '所属专题', 
          key: 'topic', 
          width:300, 
          scopedSlots: { customRender: 'topic' } 
        },
        { 
          title: '视频/子视频', 
          key: 'source', 
          width: 300, 
          scopedSlots: { customRender: 'source' } 
        },
        { 
          title: '状态', 
          dataIndex: 'status', 
          width: 100, 
          align: 'center',
          scopedSlots: { customRender: 'status' } 
        },
        { 
          title: '触发时间', 
          dataIndex: 'triggerTime', 
          width: 100, 
          align: 'center',
          scopedSlots: { customRender: 'triggerTime' } 
        },
        { 
          title: '创建时间', 
          dataIndex: 'createdTime', 
          width: 160, 
          align: 'center'
        },
        { 
          title: '操作', 
          key: 'action', 
          width: 100, 
          fixed: 'right', 
          scopedSlots: { customRender: 'action' } 
        }
      ]
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.pFilter = { sourceType: undefined, videoTitle: '' }
        this.loadPoints(1)
      }
    }
  },
  methods: {
    qTitleOf(record) {
      return record.questionnaireTitle || '—'
    },

    /* 子视频单元格内容溢出时才显示完整列表 tooltip */
    onVideoCellEnter(e, id) {
      const el = e && e.currentTarget
      this.videoTipKey = el && el.scrollHeight > el.clientHeight ? id : null
    },

    /* ===== 点位列表 ===== */
    resetFilter() {
      this.pFilter = { sourceType: undefined, videoTitle: '' }
      this.loadPoints(1)
    },
    loadPoints(page) {
      this.pLoading = true
      get('/vod/questionnaire/point/list', {
        questionnaireId: this.questionnaireId || undefined,
        sourceType: this.pFilter.sourceType || undefined,
        videoTitle: this.pFilter.videoTitle || undefined,
        pageNum: page || 1,
        pageSize: this.pPageSize
      }).then(body => {
        this.points = body.data || []
        this.pTotal = body.count != null ? body.count : this.points.length
        this.pPage = page || 1
      }).catch(e => {
        this.$message.error(e.message)
      }).finally(() => {
        this.pLoading = false
      })
    },
    onPageSizeChange(current, size) {
      this.pPageSize = size
      this.loadPoints(1)
    },
    // 批量启用/禁用（合并行：同一专题组整组操作）；带完整字段避免后端必填校验报 400
    togglePointStatus(record, checked) {
      if (this.statusLoading[record.id]) return
      const status = checked ? 1 : 0
      const list = record.pointIds || [record.id]
      const buildPayload = (id) => {
        const payload = {
          id: id,
          status: status,
          sourceType: record.sourceType,
          questionnaireId: record.questionnaireId,
          triggerTime: record.triggerTime
        }
        if (record.sourceType === 'MIX_SET_TOPIC') {
          payload.topicId = record.topicId
          payload.videoIds = (record.videos || []).map(v => v.id)
        } else {
          payload.sourceId = record.sourceId
        }
        return payload
      }
      this.$set(this.statusLoading, record.id, true)
      const chain = list.reduce((p, id) => p.then(() => put('/vod/questionnaire/point', buildPayload(id))), Promise.resolve())
      chain.then(() => {
        this.$message.success(status === 1 ? '已启用' : '已禁用')
        this.loadPoints(this.pPage)
      }).catch(e => {
        this.$message.error(e.message)
        this.loadPoints(this.pPage)
      }).finally(() => {
        this.$set(this.statusLoading, record.id, false)
      })
    },
    // 批量删除（合并行：同一专题组整组删除，作答记录保留）
    delPoint(ids) {
      const list = Array.isArray(ids) ? ids : [ids]
      const chain = list.reduce((p, id) => p.then(() => del('/vod/questionnaire/point/' + id)), Promise.resolve())
      chain.then(() => {
        this.$message.success('已删除')
        this.loadPoints(this.pPage)
      }).catch(e => this.$message.error(e.message))
    },

    /* ===== 点位弹窗 ===== */
    loadQuestionnaireOptions() {
      get('/vod/questionnaire/list', { pageNum: 1, pageSize: 200 }).then(body => {
        this.questionnaireOptions = body.data || []
      }).catch(e => this.$message.error('问卷下拉加载失败：' + e.message))
    },
    openPointModal(record) {
      if (!record) {
        // ===== 新增点位 =====
        this.pModal.id = null
        this.pModal.pointIds = null
        // 从问卷抽屉进来：新增点位默认绑定当前问卷
        this.pForm = { sourceType: 'VOD_SINGLE', questionnaireId: this.questionnaireId, triggerTime: undefined }
        this.selectedTopicId = undefined
        this.selectedTopic = null
        this.topicOptions = []
        this.selectedVideoIds = []
        this.selectedVideos = []
        this.videoOptions = []
        this.pModal.visible = true
        this.loadQuestionnaireOptions()
        return
      }
      // ===== 编辑点位（合并行：整组回显） =====
      this.pModal.id = record.id || null
      this.pModal.pointIds = record.pointIds || null
      this.pModal.visible = true
      this.loadQuestionnaireOptions()
      this.pForm = {
        sourceType: record.sourceType || 'VOD_SINGLE',
        questionnaireId: record.questionnaireId != null ? record.questionnaireId : this.questionnaireId,
        triggerTime: record.triggerTime != null ? record.triggerTime : undefined
      }
      this.selectedTopicId = record.topicId
      this.selectedTopic = record.topicId ? { id: record.topicId, title: record.topicTitle || '' } : null
      this.topicOptions = record.topicId ? [{ id: record.topicId, title: record.topicTitle || '' }] : []
      const videos = record.videos || []
      const videoIds = videos.map(v => v.id)
      // MIX_SET_TOPIC 多选绑数组；VOD_SINGLE 单选绑单值
      this.selectedVideoIds = this.pForm.sourceType === 'MIX_SET_TOPIC' ? videoIds : (videoIds[0] || undefined)
      this.selectedVideos = videos
      this.videoOptions = videos
    },
    closePModal() {
      if (!this.pModal.saving) this.pModal.visible = false
    },
    onPTypeChange() {
      this.selectedTopic = null
      this.selectedTopicId = undefined
      this.topicOptions = []
      this.selectedVideoIds = []
      this.selectedVideos = []
      this.videoOptions = []
    },
    /* 专题搜索 */
    debouncedTopicSearch(val) {
      clearTimeout(this.topicSearchTimer)
      this.topicSearchTimer = setTimeout(() => this.topicSearch(val), 350)
    },
    topicSearch(val) {
      if (!val) { this.topicOptions = []; return }
      this.topicLoading = true
      get('/vod/questionnaire/video/search', { type: 'MIX_SET_TOPIC', title: val, limit: 20 }).then(body => {
        this.topicOptions = body.data || []
      }).catch(e => this.$message.error(e.message)).finally(() => {
        this.topicLoading = false
      })
    },
    onTopicPicked(tid) {
      const t = this.topicOptions.filter(x => x.id === tid)[0]
      if (t) {
        this.selectedTopic = { id: t.id, title: t.title }
      }
      this.selectedVideoIds = []
      this.selectedVideos = []
      // 选中专题后立即加载该专题全部子视频，点击输入框时立即可选
      this.loadAllVideos()
    },
    /* 视频选择：专题下多选（点击展开加载全部子视频，本地过滤搜索）；单视频远程搜索 */
    loadAllVideos() {
      if (this.pForm.sourceType !== 'MIX_SET_TOPIC' || !this.selectedTopicId) return
      this.videoLoading = true
      get('/vod/questionnaire/video/search', { type: 'MIX_SET_TOPIC', topicId: this.selectedTopicId, limit: 500 }).then(body => {
        this.videoOptions = body.data || []
      }).catch(e => this.$message.error(e.message)).finally(() => {
        this.videoLoading = false
      })
    },
    onVideoDropdownOpen(open) {
      // 展开时加载：MIX_SET_TOPIC 加载该专题全部子视频；VOD_SINGLE 加载默认一批（按创建时间倒序），再输入关键词搜索
      if (!open) return
      if (this.pForm.sourceType === 'MIX_SET_TOPIC' && this.selectedTopicId) {
        this.loadAllVideos()
      } else if (this.pForm.sourceType === 'VOD_SINGLE') {
        this.videoSearch('')
      }
    },
    videoFilterOption(input, option) {
      // MIX_SET_TOPIC：本地过滤全部子视频；VOD_SINGLE：不过滤（走远程搜索）
      if (this.pForm.sourceType !== 'MIX_SET_TOPIC') return true
      const nodes = option.componentOptions && option.componentOptions.children
      const text = (nodes && nodes[0] && nodes[0].text) || ''
      return text.toLowerCase().indexOf((input || '').toLowerCase()) >= 0
    },
    onVideoChange(vids) {
      const arr = Array.isArray(vids) ? vids : (vids ? [vids] : [])
      this.selectedVideos = arr.map(id => this.videoOptions.filter(v => v.id === id)[0]).filter(Boolean)
    },
    onVideoSearchInput(val) {
      if (this.pForm.sourceType !== 'MIX_SET_TOPIC') {
        this.debouncedVideoSearch(val)
      }
    },
    /* 视频远程搜索（仅 VOD_SINGLE） */
    debouncedVideoSearch(val) {
      clearTimeout(this.videoSearchTimer)
      this.videoSearchTimer = setTimeout(() => this.videoSearch(val), 350)
    },
    videoSearch(val) {
      // val 为空 = 展开下拉默认加载一批（后端按 created_time 倒序）；输入关键词时按标题搜索
      this.videoLoading = true
      const params = { type: 'VOD_SINGLE', limit: 20 }
      if (val) params.title = val
      get('/vod/questionnaire/video/search', params).then(body => {
        this.videoOptions = body.data || []
      }).catch(e => this.$message.error(e.message)).finally(() => {
        this.videoLoading = false
      })
    },
    savePoint() {
      // single 模式 selectedVideoIds 是 number，统一转数组
      const videoIds = Array.isArray(this.selectedVideoIds)
        ? this.selectedVideoIds
        : (this.selectedVideoIds ? [this.selectedVideoIds] : [])
      if (!videoIds.length) {
        this.$message.error(this.pForm.sourceType === 'MIX_SET_TOPIC' ? '请选择至少一个子视频' : '请选择视频')
        return
      }
      if (this.pForm.sourceType === 'MIX_SET_TOPIC' && !this.selectedTopicId) {
        this.$message.error('请先选择专题')
        return
      }
      if (!this.pForm.questionnaireId) {
        this.$message.error('请选择问卷')
        return
      }
      if (this.pForm.triggerTime == null || this.pForm.triggerTime < 0) {
        this.$message.error('请填写合法的触发秒数')
        return
      }
      const payload = {
        sourceType: this.pForm.sourceType,
        questionnaireId: this.pForm.questionnaireId,
        triggerTime: this.pForm.triggerTime
      }
      if (this.pForm.sourceType === 'MIX_SET_TOPIC') {
        // 专题组：多选子视频批量绑定
        payload.topicId = this.selectedTopicId
        payload.videoIds = videoIds
      } else {
        payload.sourceId = videoIds[0]
      }
      if (this.pModal.id) payload.id = this.pModal.id
      if (this.pModal.pointIds && this.pModal.pointIds.length) {
        payload.pointIds = this.pModal.pointIds
      }
      this.pModal.saving = true
      const req = this.pModal.id ? put('/vod/questionnaire/point', payload) : post('/vod/questionnaire/point', payload)
      req.then(() => {
        this.$message.success(this.pModal.id ? '点位已更新' : '点位已创建')
        this.pModal.visible = false
        this.loadPoints(this.pPage)
      }).catch(e => this.$message.error(e.message)).finally(() => {
        this.pModal.saving = false
      })
    },

    // 关闭抽屉（右上角 X / 遮罩）
    onClose() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.vod-question-page { padding: 0; }
.cfg-hint { font-size: 12px; color: #8b9aab; }
.mono { font-family: monospace; color: #5c6b7a; margin-left: 4px; font-size: 12px; }
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.filter-left {
  display: flex;
  align-items: center;
}
.action-danger { color: #f5222d; }
.pager-row {
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.pager-info {
  font-size: medium;
  color: #929292;
}
.vp-video-cell {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.vp-video-line {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 20px;
}
.vp-video-no { color: #8c8c8c; margin-right: 4px; }
</style>

<style>
/* 视频下拉选项（下拉面板挂载到 body，需全局样式） */
.video-option-row { padding: 4px 0; line-height: 1.5; }
.video-option-title { font-size: 14px; color: #262626; }
.video-option-topic { color: #8c8c8c; font-size: 13px; }
.video-option-id { font-size: 12px; color: #bfbfbf; font-family: monospace; }
/* 子视频完整列表 tooltip（挂载到 body，需全局样式） */
.vp-video-tip { max-width: 420px; }
.vp-video-tip-item { line-height: 20px; white-space: normal; word-break: break-word; }
.vp-video-tip-item .vp-video-no { color: #8c8c8c; margin-right: 4px; }
</style>
